if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class carNote extends HTMLElement {
      constructor() {
        super();
        this.cartNoteData = this.querySelector("#cartNote");
        this.button = this.querySelector("button.button__save");

        this.carInit();
        if (this.button) {
          this.button.addEventListener("click", this.onSave.bind(this));
        }
      }

      carInit() {
        if (!this.cartNoteData) return;
        fetch("/cart.js")
          .then((response) => response.json())
          .then((json) => {
            if (json && json.note !== null && this.cartNoteData) {
              this.cartNoteData.value = json.note;
            }
          })
          .catch((err) => console.log(err));
      }

      onSave() {
        if (!this.cartNoteData || !this.button) return;
        let noteUpdate = this.cartNoteData.value;
        this.button.classList.add("loading");
        let body = JSON.stringify({
          note: noteUpdate,
        });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            if (response.ok) {
              this.button.classList.remove("loading");
              const details = this.closest("details");
              if (details) details.removeAttribute("open");
              return response.json();
            }
          })
          .catch((e) => {
            if (this.button) this.button.classList.remove("loading");
            console.error(e);
          });
      }
    }
  );
}

if (!customElements.get("shipping-calculator")) {
  customElements.define(
    "shipping-calculator",
    class ShippingCalculator extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector("button.button__save");

        this.shippingCountry = this.querySelector("#all--countries-shipping");
        this.countryState = this.querySelector("#AddressProvince_shipping");
        this.shippingCountryZip = this.querySelector("#ShippingAddressZip");

        this.shippingRatePackage = this.querySelector(".shipping_rate_package");
        this.shippingAddressWrapper = this.querySelector(
          ".shipping_rate_message"
        );
        this.shippingAddressCount = this.querySelector(
          ".shipping_address_count"
        );

        this.initCountries();
        if (this.button) {
          this.button.addEventListener("click", this.onSave.bind(this));
        }
      }

      initCountries() {
        if (this.shippingCountry && this.countryState) {
          if (window.Shopify && Shopify.CountryProvinceSelector) {
            new Shopify.CountryProvinceSelector(
              "all--countries-shipping",
              "AddressProvince_shipping",
              {
                hideElement: "AddressProvinceContainerNewShiping",
              }
            );
          }
        }
      }

      onSave() {
        if (!this.shippingRatePackage || !this.button || !this.shippingCountry) return;
        this.shippingRatePackage.innerHTML = "";
        if (this.shippingCountry.value !== "---") {
          this.button.classList.add("loading");
          const zip = this.shippingCountryZip ? encodeURIComponent(this.shippingCountryZip.value) : "";
          const country = encodeURIComponent(this.shippingCountry.value);
          const prov = this.countryState ? encodeURIComponent(this.countryState.value) : "";
          fetch(
            `/cart/shipping_rates.json?shipping_address%5Bzip%5D=${zip}&shipping_address%5Bcountry%5D=${country}&shipping_address%5Bprovince%5D=${prov}`
          )
            .then((response) => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error(window.shipping?.wrong_message || "Could not calculate rates");
              }
            })
            .then((response) => {
              this.button.classList.remove("loading");

              if (this.shippingAddressWrapper) this.shippingAddressWrapper.classList.remove("no-js-inline");
              if (this.shippingAddressCount && response.shipping_rates) {
                this.shippingAddressCount.innerText = `${response.shipping_rates.length}`;
              }
              if (response.shipping_rates && Array.isArray(response.shipping_rates)) {
                response.shipping_rates.forEach((rate) => {
                  let text = document.createElement("p");
                  text.setAttribute("class", "mb-0");
                  const currency = window.shopCurrencySymbol || "₹";
                  text.textContent = `${rate.name}: ${currency}${rate.price}`;
                  this.shippingRatePackage.appendChild(text);
                });
              }
            })
            .catch((e) => {
              this.button.classList.remove("loading");
              if (this.shippingAddressWrapper) this.shippingAddressWrapper.classList.add("no-js-inline");
              const errP = document.createElement("p");
              errP.className = "error mt-15";
              errP.textContent = e.message || e;
              this.shippingRatePackage.appendChild(errP);
            });
        } else {
          if (this.shippingAddressWrapper) this.shippingAddressWrapper.classList.add("no-js-inline");
          const errP = document.createElement("p");
          errP.className = "error mt-15";
          errP.textContent = window.shipping?.country_label || "Please select a country";
          this.shippingRatePackage.appendChild(errP);
        }
      }
    }
  );
}

if (!customElements.get("discount-code")) {
  customElements.define(
    "discount-code",
    class DiscountCode extends HTMLElement {
      constructor() {
        super();
        this.wrongMessage = this.querySelector(".coupon_wrong_message");
        this.button = this.querySelector("button.button__save");
        this.couponInput = this.querySelector("#coupon_code");

        if (this.button) {
          this.button.addEventListener("click", this.onSave.bind(this));
        }
        try {
          this.couponCodeValue = localStorage.getItem("coupon");
          if (this.couponInput && this.couponCodeValue) {
            this.couponInput.value = this.couponCodeValue;
          }
        } catch (e) {
          // localStorage disabled
        }
      }

      onSave() {
        const couponVal = this.couponInput ? this.couponInput.value.trim() : "";
        try {
          if (couponVal) {
            localStorage.setItem("coupon", couponVal);
          } else {
            localStorage.removeItem("coupon");
          }
        } catch (e) {
          // localStorage disabled
        }
        if (couponVal) {
          const details = this.closest("details");
          if (details) details.removeAttribute("open");
          if (this.wrongMessage) this.wrongMessage.classList.add("no-js-inline");
        } else {
          if (this.wrongMessage) this.wrongMessage.classList.remove("no-js-inline");
        }
      }
    }
  );
}

if (!customElements.get("gift-wrap-message")) {
  customElements.define(
    "gift-wrap-message",
    class GiftMessage extends HTMLElement {
      constructor() {
        super();
        this.giftMessage = this.querySelector("#giftMessage");
        this.button = this.querySelector("button.button__save");

        this.giftMessageInit();
        if (this.button) {
          this.button.addEventListener("click", this.onSave.bind(this));
        }
      }

      giftMessageInit() {
        if (!this.giftMessage) return;
        fetch("/cart.js")
          .then((response) => response.json())
          .then((json) => {
            if (json && json.attributes && json.attributes.hasOwnProperty('gift_note') && this.giftMessage) {
              this.giftMessage.value = json.attributes.gift_note;
            }  
          })
          .catch((err) => console.log(err));
      }

      onSave() {
        if (!this.giftMessage || !this.button) return;
        let giftMessageValue = this.giftMessage.value;
        this.button.classList.add("loading");
        let body = JSON.stringify({
          attributes: { gift_note: giftMessageValue },
        });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            if (response.ok) {
              this.button.classList.remove("loading");
              const details = this.closest("details");
              if (details) details.removeAttribute("open");
              return response.json();
            }
          })
          .catch((e) => {
            if (this.button) this.button.classList.remove("loading");
            console.error(e);
          });
      }
    }
  );
}
